import PetsInsured from '../PetsInsured'

export default class SaveInsuredsPetsRequest {
  /** (UUID): Identificador único de la cotización. Ejemplo: "23423-643hbf-74834hj". */
  quotationId!: string

  /** Lista de asegurados a guardar. */
  pets!: PetsInsured[]

  constructor(data: any) {
    this.quotationId = data.quotationId
    this.pets = data.pets?.map((p: any) => new PetsInsured(p))
  }
}
